/** @format */

import {safeDivide} from 'helpers/numberHelpers';

/**
 * Рассчитает цену без скидки, зная цену со скидкой, процент скидки.
 * discount приходит в диапазоне от 0 до 1
 * @param price
 */

interface Options {
  amount?: number;
  discount: number;
}

const getPriceWithoutDiscount = ({amount, discount}: Options): number => {
  if (typeof amount !== 'number') {
    return 0;
  }

  const percent = (1 - discount) * 100;
  const quotient = safeDivide(amount, percent);
  return Math.round(quotient * 100);
};

export {getPriceWithoutDiscount};
